import { useAiAssistPromptsEditorStateStore } from '../use-ai-assist-prompts-editor-state-store/use-ai-assist-prompts-editor-state-store';

export const useAiAssistPromptsEditorStateStoreActions = () => {
  const {
    setAiAssistPromptsData,
    resetAiAssistPromptsData,
    getAiAssistPrompt,
    setAiAssistPrompt,
    removeAiAssistPrompt,
  } = useAiAssistPromptsEditorStateStore((state) => ({
    setAiAssistPromptsData: state.setAiAssistPromptsData,
    resetAiAssistPromptsData: state.resetAiAssistPromptsData,
    getAiAssistPrompt: state.getAiAssistPrompt,
    setAiAssistPrompt: state.setAiAssistPrompt,
    removeAiAssistPrompt: state.removeAiAssistPrompt,
  }));

  return {
    setAiAssistPromptsData,
    resetAiAssistPromptsData,
    getAiAssistPrompt,
    setAiAssistPrompt,
    removeAiAssistPrompt,
  };
};
